import { Button, HTMLTable, Icon, Popover, Classes } from '@blueprintjs/core';
import moment from 'moment-timezone';
import React from 'react';
import { DATE_FORMAT, ERROR_TOAST_ICON, SHORT_TIME_FORMAT_24 } from '../../../utils/Constants';
import { sendDriverSms } from "../../services/smsApiService";
import { removeProvider } from '../../services/tripApiService';
import { arrowsIconTable, flexRow, htmlTableStyle, htmlHeaderStyle, openTripsTablePopover, tdPadding, verticalAlignMiddle } from '../../styles';
import { AppToaster } from "../../toastComponent";
import MenuLateTrip from '../menuComponents/menuLateTrip';
import AlertModal from '../modalComponents/alertModal';
import DialogNonParComplete from '../modalComponents/dialogNonParComplete';
import OverlayConfirmProvider from '../modalComponents/overlayConfirmProvider';
import OverlayEmulateEvents from '../modalComponents/overlayEmulateEvents';
import { showDialysisIndicator, showVipIndicator, showWcIndicator } from './../../../utils/bizCommon';
import OverlayCancelTrip from './../modalComponents/overlayCancelTrip';


export default class LateTripsTable extends React.Component {

  state = {
    isOverlayConfirmProvider: false,
    isDialogRemoveProvider: false,
    isOverlayEmulateEvents: false,
    isDialogSendSms: false,
    isOverlayConfirmTripCancellation: false,
    sortBy: 'DueTime',
    sortOrder: 'ASC',
  }

  handleConfirmedMenuClick = (event) => {
    if (this.props.selectedTrip !== null) {
      const id = event.currentTarget.id;
      this.setState({
        [id]: true,
      })
    }
  }

  handleSorting = (headerColumn) => {
    this.setState({
      sortBy: headerColumn,
      sortOrder: this.state.sortOrder === 'ASC' ? 'DESC' : 'ASC'
    }, () => this.props.refreshTrips(this.state.sortBy, this.state.sortOrder));
  }

  onModalClosed = (id) => {
    this.setState({
      [id]: false,
    })
    this.props.refreshTrips(this.state.sortBy, this.state.sortOrder)
  }

  removeProvider = async (tripNumber) => {
    try {
      await removeProvider(tripNumber);

      AppToaster.show({ message: `Provider removed from trip: ${tripNumber}.`, intent: "success", icon: 'tick', });
    }
    catch (error) {
      console.log(error);
      AppToaster.show({ message: error.response.data, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON, });
    }
  }

  sendDriverSms = async (tripNumber) => {
    try {
      await sendDriverSms(tripNumber);

      AppToaster.show({ message: 'SMS has been sent.', intent: "success", icon: 'tick', });
    }
    catch (error) {
      console.log(error);

      AppToaster.show({ message: error.response.data, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON, });
    }
  }


  render() {
    const headers = [
      { name: 'Due Date', column: 'DueTime' },
      { name: 'Due Time', column: 'DueTime' },
      { name: 'Trip Status', column: 'TripStatus' },
      { name: 'First Name', column: 'PassengerFirstName' },
      { name: 'Last Name', column: 'PassengerLastName' },
      { name: 'Serv. Level', column: 'ServiceLevelName' },
      { name: 'Client', column: 'ClientName' },
      { name: 'Service Provider', column: 'ServiceProviderName' },
      { name: 'Pickup Address', column: 'PuAddressLine1' },
      { name: 'City', column: 'PuCity' },
      { name: 'State', column: 'PuState' },
      { name: '# PAX', column: 'PassengerCount' },
      { name: '# WC', column: 'PassengerWcCount' },
      { name: 'Miles', column: 'TripMiles' },
    ];


    return (
      <>
        <HTMLTable bordered condensed interactive style={htmlTableStyle}>
          <thead>
            <tr>
              {headers.map(header => {
                return (
                  <th key={header.name} style={htmlHeaderStyle(this.props.themeName === Classes.DARK)}  onClick={() => this.handleSorting(header.column)}>
                    {header.name}
                    <Icon style={arrowsIconTable} icon={'double-caret-vertical'} iconSize={13} />
                  </th>
                );
              })}
              <th style={htmlHeaderStyle(this.props.themeName === Classes.DARK)} ></th>
            </tr>
          </thead>

          <tbody id='latetrips-table'>
            {this.props.trips.map(trip => (
              <tr key={trip.tripNumber} id={trip.tripNumber} onClick={(e) => this.props.setSelectedTrip(e)} style={verticalAlignMiddle}>
                <td style={tdPadding}>{moment.tz(trip.dueDateTime, trip.pickupTimeZone).format(`${DATE_FORMAT}`)}</td>
                <td style={tdPadding}>
                  <div style={flexRow}>
                    {moment.tz(trip.dueDateTime, trip.pickupTimeZone).format(`${SHORT_TIME_FORMAT_24} z`)}&nbsp;
                    {showVipIndicator(trip.isVip)}
                  </div>
                </td>
                <td style={tdPadding}>{trip.tripStatus}</td>
                <td style={tdPadding}>
                  <div style={flexRow}>
                    {trip.passengerFirstName}&nbsp;
                    {showDialysisIndicator(trip.customFields)}
                  </div>
                </td>
                <td style={tdPadding}>{trip.passengerLastName}</td>
                <td style={tdPadding}>
                  <div style={flexRow}>
                    {trip.serviceLevel}&nbsp;
                    {showWcIndicator(trip.wheelchairType)}
                  </div>
                </td>
                <td style={tdPadding}>{trip.clientName}</td>
                <td style={tdPadding}>{trip.serviceProviderName}</td>
                <td style={tdPadding}>{trip.pickupAddressLine1}</td>
                <td style={tdPadding}>{trip.pickupCity}</td>
                <td style={tdPadding}>{trip.pickupState}</td>
                <td style={tdPadding}>{trip.passengerCount}</td>
                <td style={tdPadding}>{trip.passengerWcCount}</td>
                <td style={tdPadding}>{Number(trip.tripMiles).toFixed(1)}</td>
                <td style={tdPadding}>
                  <Popover style={openTripsTablePopover} content={
                    <MenuLateTrip
                      handleConfirmedMenuClick={this.handleConfirmedMenuClick}
                      selectedCheckbox={this.props.selectedCheckbox}
                    />
                  }>
                    <Button small icon="menu-open" />
                  </Popover>
                </td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
        {this.state.isOverlayConfirmProvider && (
          <OverlayConfirmProvider id={'isOverlayConfirmProvider'} trip={this.props.selectedTrip} isSelectNewDriver={false} onModalClosed={this.onModalClosed} />
        )
        }
        {this.state.isDialogRemoveProvider && (
          <AlertModal id={'isDialogRemoveProvider'}
            message={`Are you sure you want to remove the provider from Trip ${this.props.selectedTrip.tripNumber}?`}
            onModalClosed={this.onModalClosed}
            onConfirm={() => this.removeProvider(this.props.selectedTrip.tripNumber)} />
        )
        }
        {this.state.isOverlayEmulateEvents && this.props.selectedTrip !== null && (
          <OverlayEmulateEvents id={'isOverlayEmulateEvents'} trip={this.props.selectedTrip} onModalClosed={this.onModalClosed} updateTrip={this.props.updateTrip} />
        )
        }
        {this.state.isDialogSendSms && (
          <AlertModal id={'isDialogSendSms'}
            message='Are you sure you want to send a SMS?'
            icon='arrow-top-right'
            intent='warning'
            onModalClosed={this.onModalClosed}
            onConfirm={() => this.sendDriverSms(this.props.selectedTrip.tripNumber)} />
        )
        }
        {this.state.isDialogNonParComplete && (
          <DialogNonParComplete id={'isDialogNonParComplete'} trip={this.props.selectedTrip} onModalClosed={this.onModalClosed} />
        )
        }
        {this.state.isOverlayConfirmTripCancellation && (
          <OverlayCancelTrip
            id={'isOverlayConfirmTripCancellation'}
            tripNumber={this.props.selectedTrip?.tripNumber}
            message={`Are you sure you want to cancel Trip ${this.props.selectedTrip?.tripNumber}?`}
            onModalClosed={this.onModalClosed}
          />
        )
        }
      </>
    )
  }
}
